<template>
  <div class="youthexchangeexperiences">
    <YouthSelectExchangeExperiences />
  </div>
</template>

<script>
import YouthSelectExchangeExperiences from "@/components/select/YouthSelectExchangeExperiences.vue";

export default {
  name: "YouthExchangeExperiences",
  components: {
    YouthSelectExchangeExperiences
  }
};
</script>
